/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';
import { UpdateDevicePlacementsDto } from '../../models/update-device-placements-dto';

export interface UpdateDevicePlacements$Params {
      body: UpdateDevicePlacementsDto
}

export function updateDevicePlacements(http: HttpClient, rootUrl: string, params: UpdateDevicePlacements$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDevice>>> {
  const rb = new RequestBuilder(rootUrl, updateDevicePlacements.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegisteredDevice>>;
    })
  );
}

updateDevicePlacements.PATH = '/api/regdevice/placement';
